import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "./constants/adminConstants";
import AdminFooterEditor from "./AdminFooterEditor";
import AdminNavbarEditor from "./AdminNavbarEditor";
import AdminVisaDetailEditor from "./AdminVisaDetailEditor";
import AdminRefundPolicyEditor from "./AdminRefundPolicyEditor";
import AdminRequirementsEditor from "./AdminRequirementsEditor";
import AdminVisaCareerEditor from "./AdminVisaCareerEditor";
import AdminScheduleMeetingEditor from "./AdminScheduleMeetingEditor";
import AdminGovernmentFeeEditor from "./AdminGovernmentFeeEditor";
import AdminEventEditor from "./AdminEventEditor";
import "./css/adminStyles.css";

const SECTIONS = [
  { key: "footer", label: "Footer", description: "Social links, company info, office details, brand text" },
  { key: "navbar", label: "Navbar", description: "Tool links, tabs, mobile menu, calendar, WhatsApp config" },
  { key: "visaDetail", label: "Visa Detail", description: "Resources section content" },
  { key: "refundPolicy", label: "Refund Policy", description: "Refund policy content" },
  { key: "requirements", label: "Requirements", description: "Document checklist, FAQ, process steps" },
  { key: "visaCareer", label: "Visa Career", description: "Departments, job listings, benefits" },
  { key: "scheduleMeeting", label: "Schedule Meeting", description: "Meeting types, info sections" },
  { key: "governmentFee", label: "Government Fee", description: "Government fee hero, quick links, info sections" },
  { key: "event", label: "Event", description: "Hero title, categories, featured events" },
];

function AdminContentManager({ user, onNavigate }) {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingSection, setEditingSection] = useState(null);

  useEffect(() => {
    fetchSections();
  }, []);

  const fetchSections = async () => {
    const token = sessionStorage.getItem("tvc_token");
    try {
      const res = await fetch(`${API_BASE_URL}/content`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.sections) {
        const list = SECTIONS.map((s) => ({
          ...s,
          content: data.sections[s.key]?.content || null,
          version: data.sections[s.key]?.version || 0,
          updatedAt: data.sections[s.key]?.updatedAt || null,
        }));
        setSections(list);
      }
    } catch (err) {
      console.error("Fetch sections error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (section) => {
    setEditingSection(section);
  };

  const handleBack = () => {
    setEditingSection(null);
    fetchSections();
  };

  if (editingSection) {
    if (editingSection.key === "footer") {
      return <AdminFooterEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "navbar") {
      return <AdminNavbarEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "visaDetail") {
      return <AdminVisaDetailEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "refundPolicy") {
      return <AdminRefundPolicyEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "requirements") {
      return <AdminRequirementsEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "visaCareer") {
      return <AdminVisaCareerEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "scheduleMeeting") {
      return <AdminScheduleMeetingEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "governmentFee") {
      return <AdminGovernmentFeeEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    if (editingSection.key === "event") {
      return <AdminEventEditor user={user} section={editingSection} onBack={handleBack} />;
    }
    return <AdminFooterEditor user={user} section={editingSection} onBack={handleBack} />;
  }

  if (loading) {
    return <div className="AdminEmptyState">Loading content sections...</div>;
  }

  return (
    <div>
      <div className="AdminCard">
        <div className="AdminCardHeader">
          <h3 style={{ margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 20, fontWeight: 700, color: "#1B2A4A" }}>
            Content Manager <span className="AdminCountBadge">{sections.length}</span>
          </h3>
        </div>

        {sections.length === 0 ? (
          <div className="AdminEmptyState">No content sections available.</div>
        ) : (
          <div className="AdminTableScroll">
          <table className="AdminTable">
            <thead>
              <tr>
                <th>Section</th>
                <th>Description</th>
                <th>Version</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sections.map((s) => (
                <tr key={s.key}>
                  <td><strong>{s.label}</strong></td>
                  <td style={{ color: "#64748b", fontSize: 13 }}>{s.description}</td>
                  <td>{s.version}</td>
                  <td style={{ fontSize: 13, color: "#64748b" }}>
                    {s.updatedAt ? new Date(s.updatedAt).toLocaleDateString() : "Not published"}
                  </td>
                  <td>
                    <button
                      className="AdminButton AdminButtonSmall"
                      onClick={() => handleEdit(s)}
                      style={{ width: "auto", padding: "6px 16px" }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminContentManager;
